import React, { useState, useEffect } from 'react';
import BoxServe from '../../../../ajax/api/index';
import { DownOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, DatePicker, Select, ConfigProvider, message } from 'antd';
import { dateFormat } from '../../../../utils';
import zhCN from 'antd/es/locale/zh_CN'; // 引入语言包
import moment from 'moment';
import dayjs from 'dayjs';
import 'moment/locale/zh-cn';
moment.locale('zh-cn'); // 注意这里设置 moment 必须放在有 import 的后面。

const { RangePicker } = DatePicker;
const { Option } = Select;

const initParams = {
  askBusiness: '-1',
  city: '',
  deviceIds: '',
  deviceNo: '',
  boxId: '',
  // endAskBusinessTime: '',
  endCreateTime: '',
  // endleaveTime: '',
  isp: '',
  // leaveMinutes: '',
  countPoints: null,
  runBusiness: '-1',
  // startAskBusinessTime: '',
  startCreateTime: '',
  // startleaveTime: '',
  onlineState: '',
  natType: '',
  tag: '',
  maxMoney: '-1',
  minMoney: '-1',
  leaveTime: '',
  page: 1,
  limit: 20,
  openIp6: '',
  machineNo: '',
  haveMoney: '',
  upOnlineState: '',
  limitStrategy: '1',
  dispatchType: '0'
};

const natTypeOption = ['nat1', 'nat2', 'nat3', 'nat4', '其它'];

export default function SearchHead(props) {
  const [form] = Form.useForm();
  const [expand, setExpand] = useState(false);

  // 运行业务时间
  const [askBusinessTime, setAskBusinessTime] = useState({
    startAskBusinessTime: '',
    endAskBusinessTime: ''
  });

  // 注册盒子时间
  const [createTime, setCreateTime] = useState({
    startCreateTime: '',
    endCreateTime: ''
  });
  // 离线时间
  const [offlineTime, setOfflineTime] = useState({
    startleaveTime: '',
    endleaveTime: ''
  });

  const [leaveTime, setLeaveTime] = useState('');

  const [businessList, setBusinessList] = useState([]);

  // 搜索
  const onFinish = (values) => {
    delete values.askBusinessTime;
    delete values.createTime;
    delete values.offlineTime;

    props.handleSearch(
      {
        ...initParams,
        ...values,
        ...askBusinessTime,
        ...createTime,
        ...offlineTime,
        leaveTime
      },
      'search'
    );
  };

  // 获取上游列表
  const getList = async () => {
    const params = {
      limit: 20,
      page: 1
    };
    try {
      const { code, data = [] } = await BoxServe.upcompanyList(params);
      if (String(code) === '0') {
        const optionsList = data?.map((item) => {
          return {
            ...item,
            label: item.upName,
            value: item.agentName
          };
        });

        setBusinessList(optionsList);
        console.log(businessList);
      } else {
        message.error('错误！');
      }
    } catch (error) {
      message.error(error.message || error.msg);
    }
  };

  //
  const onChangeDate = (dates, dateStrings, mode) => {
    if (mode === 'askBusinessTime') {
      setAskBusinessTime(() => ({
        startAskBusinessTime: dateStrings?.[0] || '',
        endAskBusinessTime: dateStrings?.[1] || ''
      }));
    }

    if (mode === 'createTime') {
      setCreateTime(() => ({
        startCreateTime: dateStrings?.[0] || '',
        endCreateTime: dateStrings?.[1] || ''
      }));
    }

    if (mode === 'offlineTime') {
      setOfflineTime(() => ({
        startleaveTime: dateStrings?.[0] || '',
        endleaveTime: dateStrings?.[1] || ''
      }));
    }
  };

  //
  const onChangeDatePicker = (dates, dateStrings, mode) => {
    if (mode === 'leaveTime') {
      setLeaveTime(dateFormat(dateStrings, 'YYYY-MM-DD HH:mm:ss'));
    }
  };

  // 重置
  const reset = () => {
    setAskBusinessTime(() => ({
      startAskBusinessTime: '',
      endAskBusinessTime: ''
    }));
    setCreateTime(() => ({
      startCreateTime: '',
      endCreateTime: ''
    }));
    setOfflineTime(() => ({
      startleaveTime: '',
      endleaveTime: ''
    }));
    setLeaveTime('');
    form.resetFields();
    props.handleSearch(
      {
        ...initParams
      },
      'reset'
    );
    props.handleReset({
      ...initParams
    });
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <div className="search">
        <Form
          form={form}
          name="advanced_search"
          onFinish={onFinish}
          labelCol={{
            flex: '130px'
          }}
          labelAlign="right"
        >
          <Row gutter={24}>
            {/* <Col span={8}>
              <Form.Item name="askBusiness" label="上游业务">
                <Input />
              </Form.Item>
            </Col> */}
            <Col span={8}>
              <Form.Item name="deviceIds" label="设备号">
                <Input placeholder="设备号" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="tag" label="设备标记">
                <Input placeholder="多个以英文逗号隔开" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="isp" label="运营商">
                <Select placeholder="请选择运行商" allowClear>
                  <Option value="联通">联通</Option>
                  <Option value="移动">移动</Option>
                  <Option value="电信">电信</Option>
                  <Option value="广电">广电</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="countPoints" label="昨日打点数">
                <Input type="number" placeholder="昨日打点数大于等于多少" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="runBusiness" label="运行业务">
                <Select placeholder="请选择运行业务" allowClear options={businessList}>
                  {/* <Option value="-1">全部</Option>
                  <Option value="-2">空值</Option>
                  <Option value="agent.x86">点心业务</Option>
                  <Option value="airship-agent">派享业务</Option>
                  <Option value="diting">聚沙业务</Option>
                  <Option value="xdnup">七牛</Option>
                  <Option value="android_up">新七牛</Option>
                  <Option value="ksc">金山</Option>
                  <Option value="ecmanager">百度</Option> */}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="askBusiness" label="指定业务">
                <Select placeholder="请选择指定业务" allowClear options={businessList}>
                  {/* <Option value="-1">全部</Option>
                  <Option value="-2">空值</Option>
                  <Option value="agent.x86">点心业务</Option>
                  <Option value="airship-agent">派享业务</Option>
                  <Option value="diting">聚沙业务</Option>
                  <Option value="xdnup">七牛</Option>
                  <Option value="android_up">新七牛</Option>
                  <Option value="ksc">金山</Option>
                  <Option value="ecmanager">百度</Option> */}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <div style={{ display: expand ? 'block' : 'none' }}>
            <Row gutter={24}>
              {/* <Col span={8}>
                <ConfigProvider locale={zhCN}>
                  <Form.Item name="askBusinessTime" label="运行业务时间">
                    <RangePicker
                      onChange={(dates, dateStrings) => onChangeDate(dates, dateStrings, 'askBusinessTime')}
                      style={{ width: '100%' }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('11:59:59', 'HH:mm:ss')]
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </Form.Item>
                </ConfigProvider>
              </Col> */}
              {/* <Col span={8}>
                <ConfigProvider locale={zhCN}>
                  <Form.Item name="createTime" label="注册盒子时间">
                    <RangePicker
                      onChange={(dates, dateStrings) => onChangeDate(dates, dateStrings, 'createTime')}
                      style={{ width: '100%' }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('11:59:59', 'HH:mm:ss')]
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </Form.Item>
                </ConfigProvider>
              </Col> */}
              {/* <Col span={8}>
                <ConfigProvider locale={zhCN}>
                  <Form.Item name="offlineTime" label="离线时间">
                    <RangePicker
                      onChange={(dates, dateStrings) => onChangeDate(dates, dateStrings, 'offlineTime')}
                      style={{ width: '100%' }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('11:59:59', 'HH:mm:ss')]
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </Form.Item>
                </ConfigProvider>
              </Col> */}
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="city" label="所在地区">
                  <Input placeholder="所在地区" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="onlineState" label="设备状态">
                  <Select placeholder="请选择设备状态" allowClear>
                    <Option value="在线">在线</Option>
                    <Option value="离线">离线</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="natType" label="网络类型">
                  <Select placeholder="请选择设备状态" allowClear>
                    {natTypeOption.map((item, index) => {
                      return (
                        <Option value={item} key={index}>
                          {item}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="maxMoney" label="昨日收益最大值">
                  <Input placeholder="昨日收益最大值" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="minMoney" label="昨日收益最小值">
                  <Input placeholder="昨日收益最小值" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="haveMoney" label="正常设备">
                  <Select placeholder="请选择" allowClear>
                    <Option value="">全部</Option>
                    <Option value="1">是</Option>
                    <Option value="2">否</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <ConfigProvider locale={zhCN}>
                  <Form.Item name="createTime" label="注册盒子时间">
                    <RangePicker
                      onChange={(dates, dateStrings) => onChangeDate(dates, dateStrings, 'createTime')}
                      style={{ width: '100%' }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('11:59:59', 'HH:mm:ss')]
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </Form.Item>
                </ConfigProvider>
              </Col>
              <Col span={8}>
                <Form.Item name="openIp6" label="IPV6">
                  <Select placeholder="请选择" allowClear>
                    <Option value="">全部</Option>
                    <Option value="1">已开启</Option>
                    <Option value="0">未开启</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="machineNo" label="上游设备号">
                  <Input placeholder="上游设备号" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="upOnlineState" label="上游在线状态">
                  <Select placeholder="请选择" allowClear>
                    <Option value="">全部</Option>
                    <Option value="在线">在线</Option>
                    <Option value="离线">离线</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="limitStrategy" label="限速策略">
                  <Select placeholder="请选择" allowClear>
                    <Option value="1">无限制</Option>
                    <Option value="2">固定限速</Option>
                    <Option value="3">智能限速</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="dispatchType" label="跨省调度">
                  <Select placeholder="请选择" allowClear>
                    <Option value="0">默认</Option>
                    <Option value="1">跨省</Option>
                    <Option value="2">不跨省</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item name="ip" label="ip">
                  <Input placeholder="ip" />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div
            style={{
              textAlign: 'center'
            }}
          >
            <Space size="small">
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button onClick={reset}>重置</Button>
              <Button
                type="dashed"
                danger
                onClick={() => {
                  setExpand(!expand);
                }}
              >
                <DownOutlined rotate={expand ? 180 : 0} /> {expand ? '收 起' : '展 开'}
              </Button>
              {/* <span
                style={{
                  fontSize: 14,
                  color: "#4096ff",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setExpand(!expand);
                }}
              >
                <DownOutlined rotate={expand ? 180 : 0} />{" "}
                {expand ? "收 起" : "展 开"}
              </span> */}
            </Space>
          </div>
        </Form>
      </div>
      <div className="line"></div>
    </>
  );
}
